import React, { useCallback } from "react";
import axios from "axios";
import Dialog from "rc-dialog";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { openHTMLWindow } from "../courses/utils";

export const NotifyStudentModal = ({ items, contextData, bulkData = {}, addGlobalMessage, close, onSuccess }) => {
    const notifyStudents = useCallback(async (students) => {
        const values = items.filter(Boolean);
        axios
            .post(`/v1/courses/${contextData?.courseDetail?.uuid}/notify/`, {
                users: values,
                notification_type: "new-course"
            })
            .then((response) => {
                // console.info("Notified", response.data.users?.length || 0, "users");
                // onSuccess(response.data.users?.length || 0);
                addGlobalMessage({
                    title: `De geselecteerde cursisten zijn succesvol uitgenodigd.`
                });
                if (typeof onSuccess === "function") {
                    onSuccess();
                }
                close();
            })
            .catch((error) => {
                // setLoading(0);
            });
    });

    const footerButtons = [
        <button
            type="button"
            className="btn btn-light"
            key="no"
            onClick={() => {
                close();
            }}
        >
            Nee, deze cursisten niet uitnodigen
        </button>,
        <button
            type="button"
            className="btn btn-primary"
            key="yes"
            onClick={() => {
                notifyStudents(items, contextData?.courseDetail);
            }}
        >
            Nodig deze cursisten uit
        </button>
    ];

    return (
        <>
            <Dialog title={"Stuur uitnodiging naar cursisten "} onClose={() => close()} visible={true} animation="fade" footer={footerButtons}>
                <p className={"paragraph"}>
                    De volgende {items?.length || ""} cursist{items?.length !== 1 ? "en" : ""} worden uitgenodigd:
                </p>
                <table className="table">
                    <thead>
                        <tr>
                            <th>NIBHV nummer</th>
                            <th>Naam</th>
                            <th>E-mailadres</th>
                            <th>Laatst uitgenodigd</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(bulkData)
                            .filter((uuid) => items.includes(uuid))
                            .map((key, index) => {
                                const user = bulkData[key];
                                const course = contextData?.courseDetail;
                                const notified_by_tip_id = `tip-invited-by-${user.uuid}`;

                                const notificationType = "new-course";
                                const handleShowMailPreview = (event, userUUID) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    openHTMLWindow(`/v1/courses/${course.uuid}/notification-templates/${notificationType}/preview/${userUUID}/`).catch((error) => {
                                        onError(error);
                                    });
                                };

                                return (
                                    <tr className="inactive" key={key}>
                                        <td>{user.nibhv_number}</td>
                                        <td>{user.full_name}</td>
                                        <td>{user.email}</td>
                                        <td>
                                            {user.last_notified ? (
                                                <>
                                                    <time dateTime={user.last_notified.notified} data-tip data-for={notified_by_tip_id}>
                                                        {moment(user.last_notified.notified).format("DD-MM-YYYY HH:mm")}
                                                    </time>
                                                    <ReactTooltip id={notified_by_tip_id} effect="solid" place="bottom">
                                                        Door {user.last_notified.notified_by.full_name}
                                                    </ReactTooltip>
                                                </>
                                            ) : (
                                                <i className="fa fa-times" title="Gebruiker is nooit uitgenodigd" data-tip data-for="tip-notification-info" />
                                            )}
                                        </td>
                                        <td>
                                            <button
                                                className="btn-light fa fa-eye"
                                                onClick={(event) => handleShowMailPreview(event, user.uuid)}
                                                data-tip
                                                data-for="tip-show-preview"
                                            >
                                                Voorbeeld
                                            </button>
                                            <ReactTooltip id="tip-notification-info" effect="solid" place="bottom">
                                                <p>Deze gebruiker is nooit via NIBHV Competent op de hoogte gebracht.</p>
                                            </ReactTooltip>
                                            <ReactTooltip id="tip-show-preview" effect="solid" place="left">
                                                <p>Toon een voorbeeld van de e-mail die naar deze gebruiker zal worden gestuurd.</p>
                                            </ReactTooltip>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </Dialog>
        </>
    );
};
